import { useAppSelector } from "@/store/app/hooks";
import type { RootState } from "@/store/app/storeTypes";

/**
 * Returns the current theme from Redux (institution custom colors).
 * Prefer Tailwind semantic classes (text-foreground, bg-sidebar, etc.) when possible—
 * they use the same CSS vars that ThemeVarsProvider sets from this theme.
 * Use this hook when you need a raw color value (e.g. Recharts, custom CSS vars).
 */
export const useThemeColor = (): RootState["themeColor"] => {
  return useAppSelector((state) => state.themeColor);
};
